import io, {Socket} from "socket.io-client";
import config from "../config";


export class SocketApi {
    static socket:null | Socket = null

    static createConnection(){
        this.socket = io(`${config.api.baseUrl}`)
        this.socket.on('connect', ()=>{
            console.log('connect')
        })
    }
}
